import React, {useState} from 'reactn';
import {DeleteOutlined, EditOutlined, PictureOutlined} from '@ant-design/icons';
import { Popover, notification, Button, Modal, Input, message, Form, Typography } from 'antd';
import { useFirestore, useStorage } from 'reactfire';

const SingleShowTest = (props) => {
    const { TextArea } = Input;
    const { Title } = Typography;
    const [imgLoading, setImageLoading] = useState(false);
    const [popup, setPopup] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [imageURL, setImageURL] = useState(null);
    const storage = useStorage();
    const [state, setState] = useState({
        note: props.test_desc,
    })
    const firestore = useFirestore();
    const query = firestore.collection("Investigation_records").doc(props.id);

    const deleteteItrem = () => {
        query.delete().then(() => {
            props.deletedRecord();
            notification.open({
                message: 'Record Deleted',
                icon: <DeleteOutlined style={{ color: '#f00' }} />,
            });
        })
        // console.log('deleting' , props.id)
    }
    const getValue = e => {
        setState({note: e.target.value});
    }

    const onSubmitEditNote = valform => {
        query.update({['test_info.note']: valform.note, test_image_url: imageURL}).then(() => {
            message.success('Test info updated');
            setModalVisible(false);
            props.deletedRecord();
        });
    }

    const uploadFile = (event) => {
        setImageLoading(true);
        const currImage = event.target.files[0];
        const uploadTask = storage.ref(`investigation/${currImage.name}`).put(currImage);
        uploadTask.on("state_changed", snapshot => {}, error => {console.log(error)}, () => {
            storage.ref("investigation").child(currImage.name).getDownloadURL().then( url => {
                setImageURL(url);
                setImageLoading(false);
            });
        });
    }

    return (
        <>
        <li>
            <h4>{props.test_name}</h4>
            <p>{props.test_desc}</p>
            {props.image && <PictureOutlined onClick={() => setShowImage(!showImage)} />}
            <Popover
                content={<a onClick={deleteteItrem}>Delete</a>}
                title="Are you sure you want to delete?"
                trigger="click"
                visible={popup}
                onVisibleChange={() => setPopup(!popup) }
            >
                <DeleteOutlined />
            </Popover>
            <EditOutlined style={{cursor: 'pointer'}} onClick={() => setModalVisible(true)} />
        </li>


        <Modal title="Edit test information" width='500px' footer={null} visible={isModalVisible} onCancel={() => setModalVisible(false)}>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Title level={4}>{props.test_name}</Title>
                {!imageURL && !imgLoading && <label className="uploadFile"> Upload Image
                    <input onChange={uploadFile} type="file" size="60" />
                </label> }
                {!imageURL && imgLoading && <span>Uploading</span>}

                {imageURL && <span>Image Uploaded</span>}
            </div>
            <Form
                name="edittest"
                onFinish={onSubmitEditNote}
                initialValues={{
                    ['note']: state.note,
                }}
            >
                <Form.Item
                    style={{marginBottom: '10px'}}
                    name="note"
                >
                    <TextArea onChange={getValue} value={state.note} placeholder="Enter Note" rows={2} />
                </Form.Item>
                <Button type="primary" htmlType="submit">Update</Button>
             </Form>
        </Modal>


        <Modal width='600px' footer={null} header={null} visible={showImage} onCancel={() => setShowImage(false)}>
            <img style={{width: '100%'}} src={props.image} />
            <a download href={props.image} target="_blank">Download</a>
        </Modal>
        </>
    );
}

export default SingleShowTest;
